import { render, staticRenderFns } from "./SplitDocumentDialog.vue?vue&type=template&id=b465f03e&"
import script from "./SplitDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./SplitDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports